import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDevice } from '@panel/commons/helpers/device';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@panel/commons/hooks';
import { PreviewOperations, PreviewSelectors } from '../../ducks/preview';
import { getUrlPosting } from '@panel/avisos/helpers/getUrlPosting';
import Loader from '@panel/commons/lib/SimpleLoader';
import checkIcon from '../../../assets/img/checkConfirmation.svg';
import {
  WrapperBackground,
  Container,
  CTA,
  LoaderWrapper,
  ImgCheck,
  TextContainer,
  Title,
  Subtitle,
  CtaContainer
} from './styles';
import { sendSuccessfulPublicationTrackingInfo } from '../../utils/adaptStepDataAndSendTrackinInfo';

const SuccessfulPublication = () => {
  const device = getDevice();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [postingId, isDraftFromPanel] = useQuery(useLocation(), ['postingId', 'isDraftFromPanel']);
  const { postingData, loadingPostingData, errorPostingData } = useSelector(PreviewSelectors.getPreviewState);
  const [trackingInfoSent, setTrackingInfoSent] = useState(false);
  const redirectToPanel = () => {
    history.push('/avisos');
  };

  const getLinkToPostingUrl = urlPosting => `../${t('panel.url.property')}/${getUrlPosting(urlPosting, postingId)}`;

  const redirectToPosting = () => {
    const link = getLinkToPostingUrl(postingData.urlPosting);
    window.open(link, '_blank');
  };

  useEffect(() => {
    if (postingId && !errorPostingData) {
      dispatch(PreviewOperations.getPostingData(postingId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingId]);

  useEffect(() => {
    if (postingId && !errorPostingData && !trackingInfoSent && postingData) {
      sendSuccessfulPublicationTrackingInfo(postingId, postingData, isDraftFromPanel);
      setTrackingInfoSent(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingId, postingData, trackingInfoSent]);

  return (
    <WrapperBackground device={device}>
      <Container data-publi='successful-publication' device={device}>
        <ImgCheck src={checkIcon} alt='check icon' device={device} />
        <TextContainer className='text-container'>
          <Title data-publi='successful-publication-title' className='title'>
            {t('professionalPubli.successfulPublication.title')}
          </Title>
          <Subtitle data-publi='successful-publication-subtitle' className='subtitle'>
            {t('professionalPubli.successfulPublication.subtitle')}
          </Subtitle>
        </TextContainer>
        <CtaContainer className='cta-container'>
          <CTA data-publi='successful-publication-cta-goToPanel' device={device} onClick={redirectToPanel}>
            {t('professionalPubli.successfulPublication.cta.panel')}
          </CTA>
          <CTA
            data-publi='successful-publication-cta-goToPosting'
            device={device}
            className='PRINCIPAL'
            onClick={redirectToPosting}
          >
            {t('professionalPubli.successfulPublication.cta.posting')}
          </CTA>
        </CtaContainer>
      </Container>
      {loadingPostingData && (
        <LoaderWrapper>
          <Loader width='96px' height='96px' />
        </LoaderWrapper>
      )}
    </WrapperBackground>
  );
};

export default SuccessfulPublication;
